import { Tag, TagPropsStrict } from '@servicetitan/design-system';
import classNames from 'classnames';
import { FC } from 'react';
import { AppointmentStatus, MembershipStatus } from '../../../api';
import * as Styles from './status.module.less';

export const StatusDue: FC<{ due: boolean }> = ({ due }) => {
    return due ? (
        <Tag color="warning" compact>
            Visit due
        </Tag>
    ) : null;
};

export const StatusRenewed: FC<{ renewed: boolean }> = ({ renewed }) => {
    return renewed ? (
        <Tag color="info" compact subtle>
            Renewed
        </Tag>
    ) : null;
};

export const StatusAllLocations: FC<{ allLocations: boolean }> = ({ allLocations }) => {
    return allLocations ? <Tag compact>All Locations</Tag> : null;
};

const statusesAppointment: Record<AppointmentStatus, [TagPropsStrict['color'], boolean, string]> = {
    [AppointmentStatus.Scheduled]: ['inactive', false, 'Scheduled'],
    [AppointmentStatus.InProgress]: ['success', true, 'In Progress'],
    [AppointmentStatus.Completed]: ['success', false, 'Completed'],
};

export const StatusAppointment: FC<{ status: AppointmentStatus }> = ({ status }) => {
    const data = statusesAppointment[status];

    return data ? (
        <Tag color={data[0]} subtle={data[1]} compact>
            {data[2]}
        </Tag>
    ) : null;
};

const statusesMembership: Record<MembershipStatus, [string, string]> = {
    [MembershipStatus.Active]: ['bg-yellow-500', 'Active'],
    [MembershipStatus.Suspended]: ['bg-yellow-500', 'Suspended'],
    [MembershipStatus.Expired]: ['bg-yellow-500', 'Expired'],
    [MembershipStatus.Canceled]: ['bg-yellow-500', 'Canceled'],
    [MembershipStatus.Deleted]: ['bg-yellow-500', 'Deleted'],
};

export const StatusMembership: FC<{ status?: MembershipStatus }> = ({ status }) => {
    const data = status ? statusesMembership[status] : undefined;

    return data ? (
        <Tag compact subtle>
            <div className={classNames(Styles.statusTag, data[0])} />
            {data[1]}
        </Tag>
    ) : null;
};
